import type { ManualEstimateReviewTracker } from "@rebuild/shared";
import StageBadge from "./StageBadge";
import { estimateUrl } from "./manualEstimateReviewsUtils";

interface ManualEstimateReviewsTableProps {
  trackers: ManualEstimateReviewTracker[];
  onSelect: (tracker: ManualEstimateReviewTracker) => void;
}

function EstimateLink({ estimateId }: { estimateId: string }) {
  return (
    <a
      href={estimateUrl(estimateId)}
      target="_blank"
      rel="noreferrer"
      onClick={(e) => e.stopPropagation()}
      className="text-blue-600 hover:underline font-mono text-sm break-all"
    >
      {estimateId}
    </a>
  );
}

function ManualEstimateReviewsTable({ trackers, onSelect }: ManualEstimateReviewsTableProps) {
  return (
    <table className="w-full text-left border-collapse">
      <thead>
        <tr className="border-b border-gray-200">
          <th className="py-2 px-3 text-sm font-semibold text-gray-700 w-20">ID</th>
          <th className="py-2 px-3 text-sm font-semibold text-gray-700 w-48">Stage</th>
          <th className="py-2 px-3 text-sm font-semibold text-gray-700 w-64">Original Org</th>
          <th className="py-2 px-3 text-sm font-semibold text-gray-700 w-64">Estimate Type</th>
          <th className="py-2 px-3 text-sm font-semibold text-gray-700">Manual Estimate Review</th>
          <th className="py-2 px-3 text-sm font-semibold text-gray-700 w-48">Date-Time Created</th>
        </tr>
      </thead>
      <tbody>
        {trackers.map((tracker) => (
          <tr
            key={tracker.uuid}
            onClick={() => onSelect(tracker)}
            className="border-b border-gray-100 hover:bg-gray-50 cursor-pointer align-top"
          >
            <td className="py-2 px-3 text-gray-600 font-mono text-sm">{tracker.id}</td>
            <td className="py-2 px-3">
              <StageBadge stage={tracker.stage} />
            </td>
            <td className="py-2 px-3 text-gray-800 font-medium">{tracker.originalOrgName || tracker.originalOrgId}</td>
            <td className="py-2 px-3 text-gray-600">{tracker.originalEstimateType ?? "—"}</td>
            <td className="py-2 px-3">
              <EstimateLink estimateId={tracker.manualEstimateReviewId} />
            </td>
            <td className="py-2 px-3 text-gray-600">{new Date(tracker.createdAt).toLocaleString()}</td>
          </tr>
        ))}
      </tbody>
    </table>
  );
}

export default ManualEstimateReviewsTable;
